var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 54,
    width: 43,
    height: 15,
    rx: 1,
    fill: "#3C4148"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 132,
    width: 42,
    height: 13,
    rx: 1,
    fill: "#3C4148"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 80,
    width: 42,
    height: 16,
    rx: 1,
    fill: "#3C4148"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 44,
    height: 13,
    rx: 1,
    fill: "#E2E2E2",
    fillOpacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 30,
    width: 43,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 43,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 105,
    width: 43,
    height: 16,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 131,
    width: 43,
    height: 15,
    rx: 2,
    fill: "#718095"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 30,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 80,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 80,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 132,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 30,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#718095"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 54,
    width: 42,
    height: 16,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 105,
    width: 42,
    height: 16,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 131,
    width: 42,
    height: 15,
    rx: 2,
    fill: "#E2E2E2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 54,
    width: 44,
    height: 15,
    rx: 1,
    fill: "#718095"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 105,
    width: 44,
    height: 16,
    rx: 1,
    fill: "#718095"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 106,
    width: 44,
    height: 15,
    rx: 1,
    fill: "#718095"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 54,
    width: 44,
    height: 15,
    rx: 1,
    fill: "#718095"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons);
export default __webpack_public_path__ + "static/media/buttons.82838f54bccd1d2b0a94294ac569bcf6.svg";
export { ForwardRef as ReactComponent };